<template>
    <document-edit v-if="editMode || showEditDocumentSignatory" :is_reviewing="is_reviewing"></document-edit>
    <document-view v-else :is_reviewing="is_reviewing"></document-view>
</template>
<script>
    import documentMixin from "../../../utils/document-mixin";
    import documentUpload from "./edit.vue"
    import viewDocumentUpload from "./view.vue"
    import applicationMixin from "../../../utils/application-mixin";
    import * as types from "../../../stores/constants";
    import useModuleStore from "../../../stores";


    export default {
        name: "documentUploadIndex",
        mixins: [documentMixin, applicationMixin],
        components: {
            'document-edit' : documentUpload,
            'document-view' : viewDocumentUpload,
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.isPiiDataMaskedDocument) {
                    if (vm.$route.path.includes('/application/edit')) {
                        vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/documents_mask/`});
                    } else if (vm.$route.path.includes('/upload_documents')) {
                        vm.$router.push({path: `/application/view/${vm.$route.params.application_reference}/upload_documents_mask/`});
                    }
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            let vm = this;
            // if (!!this.abortRouteLeave){
            //     next();
            //     return;
            // }

            // Avoid save when UI is masked
            if (vm.isPiiDataMaskedDocument) {
                next(true);
                return;
            }

            if( from.fullPath.includes('/application/edit') && !vm.hasMerchantControl ) {
                if( !to.query.hasOwnProperty('recall') || (to.query.hasOwnProperty('recall') && to.query.recall !== '0')  )
                {
                    let dest = to.fullPath.replace('edit', 'view');
                    this.$router.push({ path: dest, query: { recall:'0' } })
                }
            }

            if(!this.checkDestinationRoute(to, from) && !this.noMerchantControlWithUploadToReview(to, from)){
                //if user is going backwards, don't validate
                if (this.editMode && this.pageHasData() && !this.disable_go_back_warning_modal) {
                    this.alertBackRouteWarning((doCall = true) => next(doCall))
                } else {
                    next()
                    return;
                }
            }else {
                //let signatory_must_go_next = (this.isSignerUser && (this.isOpenApplication || (vm.signerHaveSigned && vm.isAwaitingSignature)));
                let signatory_and_cannot_upload_doc = this.isSignerUser && !(vm.isAwaitingSignature && !vm.signerHaveSigned);
                if ((!this.isOpenApplication && !this.isSignerUser)) {
                    //for merchant user (main user), just go next without doc process if the status is not open
                    next(true);
                }
                else if (signatory_and_cannot_upload_doc) {
                    //for additional signer user (not main user), if no document upload is allowed, just go next without doc process
                    next(true);
                    //run this only when signer is not idpal
                } else if ((from.fullPath.includes('/application/edit') || this.merchantToUpload || this.isSignerUser) && this.signerOwner.idpal_verification !== '1') { //or merchant to upload documents
                    //if merchant_control === '0' switch edit to view before change route
                     if (this.isSignerUser && this.signatory_has_upload_documents) {
                         this.signatory_has_upload_documents = false;
                         next();
                    } else {
                        // If open application and in edit do validate and save
                        this.uploadDocument(to.path).then(response => {
                            useModuleStore().commit(types.TOGGLE_LOADING, false);
                            if (response) { //result shows upload successfully
                                if (vm.isSignerUser) {
                                    next(new Error());
                                } else {
                                    next(response);
                                }
                            }
                        }).catch((err) => {
                            if (err) {
                                console.error(err);
                            }
                        });
                    }
                } else {
                    // TODO: This part may have some issues
                    new Promise((resolve, reject) => {
                        if (vm.askHowSignersUploadDocuments()) {
                            resolve();
                        } else {
                            reject();
                        }
                    }).then(response => {
                        next();
                    })
                    .catch((err) => {
                        if (err) {
                            console.error(err);
                        }
                    });
                }
            }
        },
        mounted() {

        },
        computed: {
            editMode: function() {

                // console.log('editMode->Open', this.isOpenApplication)
                // console.log('merchant_to_upload', this.merchantToUpload)
                // console.log('merchant_control', this.hasMerchantControl)
                return ( this.isOpenApplication && !this.isSignerUser && ( this.merchantToUpload || this.hasMerchantControl || this.urlHasEdit ) )
            },
            hasMerchantControl: function(){
                return ( !!this.merchant.merchant_control && this.merchant.merchant_control === '1' )
            },
            merchantToUpload: function(){
                return ( !!this.merchant.merchant_to_upload_document && this.merchant.merchant_to_upload_document === '1'  )
            },
            urlHasEdit: function(){
                return ( window.location.pathname.includes( "/edit/" ) )
            },
        },
        methods: {
            pageHasData: function (){
                return this.formHasValues($('#document_upload_form'))
            },
            noMerchantControlWithUploadToReview:function(to, from) {
                //assumption upload_documents is only used when merchant_to_upload_docs is 1 and mechant_control is 0
                //console.log('noMerchantControlWithUploadToReview:=>' , to, from)
                return from.fullPath.includes('/upload_documents') && to.fullPath.includes('/review');
            },
        },
        watch: {
            'merchant.pii_masked_document': {
                immediate: true,
                handler: function (val) {
                    let vm = this;
                    if (val == '1') {
                        if (vm.isSignerUser) {
                            vm.$router.push({path: `/application/view/${vm.$route.params.application_reference}/upload_documents_mask/`});
                        } else {
                            if (vm.$route.path.includes('/application/edit')) {
                                vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/documents_mask/`});
                            } else if (vm.$route.path.includes('/upload_documents')) {
                                vm.$router.push({path: `/application/view/${vm.$route.params.application_reference}/upload_documents_mask/`});
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>